import React from 'react';

import { Spacer, Button, Message, Link } from 'src/core/components';
import { getTemplateFile } from 'src/utils';
import messages from './messages';

const DownloadFilesList = () => (
  <div>
    <Spacer key="download-96" bottom={8}>
      <Button
        type="tertiary"
        iconName="download-bold"
        iconPosition="left"
        label={(
          <Link
            href={`${getTemplateFile()}`}
            target="_blank"
          >
            <Message message={messages.download96} />
          </Link>
        )}
        iconColor="blue"
        className="dna-files-details__download-link"
      />
    </Spacer>
    <Spacer key="download-384" bottom={8}>
      <Button
        type="tertiary"
        iconName="download-bold"
        iconPosition="left"
        label={(
          <Link
            href={`${getTemplateFile(384)}`}
            target="_blank"
          >
            <Message message={messages.download384} />
          </Link>
        )}
        iconColor="blue"
        className="dna-files-details__download-link"
      />
    </Spacer>
  </div>
);

DownloadFilesList.propTypes = {};

export default DownloadFilesList;
